<template>
  <div class="ca-contact">
    <h2 class="ca-contact__title">联系我们</h2>
    <div class="ca-contact__body">
      <div class="ca-contact__info">
        <div v-for="item in CONTACT_ITEMS" :key="item.label" class="ca-contact__row">
          <span class="ca-contact__label">{{ item.label }}</span>
          <span class="ca-contact__value">{{ item.value }}</span>
        </div>
      </div>
      <!-- 右：默认静态位置图，点击后加载腾讯地图（官方底图，合规要求；加载失败兜底提示） -->
      <div class="ca-contact__map">
        <div v-if="mapFailed" class="ca-contact__map-fail">地图加载失败，请稍后重试</div>
        <template v-else>
          <div v-if="!mapActivated" class="ca-contact__map-static" @click="activateMap">
            <img :src="mapStaticImg" alt="公司地址位置图" class="ca-contact__map-img" />
            <span class="ca-contact__map-tip">点击查看地图</span>
          </div>
          <div v-show="mapActivated" ref="map" class="ca-contact__map-container" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const CONTACT_ITEMS = [
  { label: '公司名称', value: '上海汇招信息技术有限公司' },
  { label: '购买CA联系电话', value: '010-89170159' },
  { label: 'CA客服时间', value: '8:30-12:00 13:30-17:30' },
  { label: '传真号码', value: '021-62717128' },
  { label: '电子邮箱', value: 'service@ebidding.com.cn' },
  {
    label: '公司地址',
    value: '上海市浦东新区锦绣东路2777弄锦绣申江36号楼501室',
  },
  {
    label: 'CA办理地址',
    value: '山西省太原市小店区凯通大厦506',
  },
]

// ⚠️ 腾讯地图 key
const TENCENT_MAP_KEY = 'NWKBZ-I32KW-KTORP-YMAIU-QKVIQ-4UBYU'
// 公司地址坐标（上海市浦东新区锦绣东路2777弄）—— 上线前与运营核对
const COMPANY_LOCATION = { lat: 31.237, lng: 121.62 }

export default {
  name: 'CaContact',
  data() {
    return {
      CONTACT_ITEMS,
      mapFailed: false,
      mapActivated: false,
      mapStaticImg: require('@/views/ca/assets/map.jpg'),
    }
  },
  methods: {
    activateMap() {
      this.mapActivated = true
      this.loadMap()
    },
    loadMap() {
      if (!TENCENT_MAP_KEY) {
        this.mapFailed = true
        return
      }
      const script = document.createElement('script')
      script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${TENCENT_MAP_KEY}`
      script.onload = () => this.initMap()
      script.onerror = () => {
        this.mapFailed = true
      }
      document.head.appendChild(script)
    },
    initMap() {
      try {
        const center = new window.TMap.LatLng(COMPANY_LOCATION.lat, COMPANY_LOCATION.lng)
        const map = new window.TMap.Map(this.$refs.map, { center, zoom: 15 })
        this.marker = new window.TMap.MultiMarker({
          map,
          geometries: [{ id: 'hq', position: center }],
        })
      } catch (e) {
        this.mapFailed = true
      }
    },
  },
}
</script>
